<template>
  <body>
    <aside class="Blk-1">
      <img class="previewPortada" :src="EdiPerVista.imgPortada"/>
      <!-- Caracteres del índice: {{longitudInd}} -->
    </aside>
    <section class="Blk-2">
      <div class="Form">
        <div class="EtiCampH" v-show="VerSelectPubPer">
          <p id="PubReg">Publicaciones registradas</p>
          <select name="nomPubPer" id="SelPubReg" class="campo"
            v-model="PubPerSel" @change.prevent="mostrarPubPerVista(PubPerSel)">
            <option v-for="pub_per in pubs_per" :key="pub_per._id" :value="pub_per">{{pub_per.nombre}}</option>
          </select>
        </div>
        <form @change="cambioFormPubPer" class="formPubPer">
          <div class="EtiCampH" v-show="!VerSelectPubPer">
            <p>Nombre de la publicación</p>
            <input type="text" name="nomPubPer" class="campo" ref="nomPubPer"
              v-model.trim="PubPerVista.nombre">
          </div>
          <div class="EtiCampH">
            <p>Editor</p>
            <input type="text" name="editor" class="campo" id="editor" ref=""
            v-model.trim="PubPerVista.editorial"
            :disabled = '!habBotAndCamp.habPubPer'>
          </div>
          <div class="TipoM">
            <div class="TipoM">
              <div class="EtiCampV">
                <p>Ciudad</p>
                <input type="text" name="ciudad" class="campo" id="" ref=""
                  v-model.trim="PubPerVista.ciudad"
                  :disabled = '!habBotAndCamp.habPubPer'>
              </div>
              <div class="EtiCampV">
                <p>País</p>
                <input type="text" name="pais" class="campo" id="" ref=""
                  v-model.trim="PubPerVista.pais"
                  :disabled = '!habBotAndCamp.habPubPer'>
              </div>
            </div>
            <div class="TipoM">
              <div class="EtiCampV">
                <p>N° ISSN</p>
                <input type="text" name="ISSN" class="campo" ref=""
                  v-model.trim="PubPerVista.ISSN"
                  :disabled = '!habBotAndCamp.habPubPer'>
              </div>
              <div class="EtiCampV">
                <p>Idioma</p>
                <input type="text" name="idioma" class="campo" ref="" list="idiomas" autocomplete="off"
                  v-model.trim="PubPerVista.idioma"
                  :disabled = '!habBotAndCamp.habPubPer'>
                <datalist id="idiomas">
                  <option value="Español">Español</option>
                  <option value="Francés">Francés</option>
                  <option value="Italiano">Italiano</option>
                  <option value="Inglés">Inglés</option>
                  <option value="Japonés">Japonés</option>
                  <option value="Portugués">Portugués</option>
                </datalist>
              </div>
            </div>
            <div class="EtiCampV">
              <p>Nombre corto</p>
              <input type="text" name="ISSN" class="campo" ref=""
                v-model.trim="PubPerVista.nombreCorto"
                :disabled = '!habBotAndCamp.habPubPer'>
            </div>
          </div>
        </form>
        <div class="Btn-EdiPerTel">
          <BotonesCRUD
            :desacMas="!habBotAndCamp.actMas2"
            :desacEdit="!habBotAndCamp.actEdi2"
            :desacMenos="!habBotAndCamp.actMen2"
            :desacSave="!habBotAndCamp.actSav2"
            @nuevo="nuevaEdiPer"
            @editar="editarEdiPer"
            @del="borrarEdiPer"
            @save="saveEdiPer"
          />
        </div>
        <div id="edicionesSelect">
          <div class="EtiCampH">
            <p>Ediciones</p>
            <select
              name="EdiPer"
              id="edicionP"
              class="campo"
              :disabled = 'habBotAndCamp.habEdiPer'
              v-model="EdiPerSel" @change.prevent="mostrarEdiPerVista(EdiPerSel._id)">
              <option v-for="numVolEdiPer in numVolEdiPers"
                :key="numVolEdiPer._id"
                :value="numVolEdiPer">
                  {{numVolEdiPer.volumen ? (' Volumen ' + numVolEdiPer.volumen  + '-') : `` }}
                  {{numVolEdiPer.numero ? ('Número ' + numVolEdiPer.numero) : `` }}
                  {{numVolEdiPer.mes ? (' | ' + mes(numVolEdiPer.mes)) : `` }}
                  - {{numVolEdiPer.anyo}}
              </option>
              <!-- N°{{numVolEdiPer.numero}}   (Vol. {{numVolEdiPer.volumen}}) {{numVolEdiPer.anyo}} -->
            </select>
          </div>
        </div>
        <form @change="cambioFormEdiPer">
        <div class="TipoM">
          <div class="TipoM">
            <div class="EtiCampV">
              <p>Número</p>
              <input type="text" name="numero" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.numero"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
            <div class="EtiCampV">
              <p>Volumen</p>
              <input type="text" name="volumen" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.volumen"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
          </div>
          <div class="TipoM">
            <div class="EtiCampV">
              <p>Mes</p>
              <select
                name="mes" class="campo" id="SelMes"
                :disabled = '!habBotAndCamp.habEdiPer'
                v-model.trim="EdiPerVista.mes">
                <option v-for="(mes, i) in meses" :key="i" :value="i"
                :selected="mes == '<Elige mes de edición>'? true : false">{{mes}}</option>
              </select>
            </div>
            <div class="EtiCampV">
              <p>Año</p>
              <input type="text" name="anyo" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.anyo"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
          </div>
        </div>
        <div class="EtiCampI" id="indice">
          <p>Índice</p>
          <textarea
            name="indice"
            class="indice"
            ref="indiceRef"
            id="in-dice"
            :disabled = '!habBotAndCamp.habEdiPer'
            spellcheck="false"
            v-model.trim="EdiPerVista.indice">
          </textarea>
        </div>
        <div class="formInd">
          <button @click.prevent="formatoIndice" :disabled = '!habBotAndCamp.habEdiPer'>Formato índice</button>
        </div>
        <div class="TipoM">
          <div class="TipoM">
            <div class="EtiCampV">
              <p>Páginas</p>
              <input type="text" name="numPag" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.numPaginas"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
            <div class="EtiCampV">
              <p>Tamaño</p>
              <input type="text" name="size" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.size"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
          </div>
          <div class="TipoM">
            <div class="EtiCampV">
              <p>Ejemplares</p>
              <input type="text" name="ejemplares" class="campo" id="" ref=""
                v-model.trim="EdiPerVista.ejemplares"
                :disabled = '!habBotAndCamp.habEdiPer'>
            </div>
            <div class="EtiCampV">
            </div>
          </div>
        </div>
        <div class="TipoM">
          <div class="EtiCamp2">
            <p>Papel</p>
            <input type="checkbox" name="ediP" class="check"
              v-model.trim="EdiPerVista.edicionP"
              :disabled = '!habBotAndCamp.habEdiPer'>
          </div>
          <div class="EtiCamp2">
            <p>Digital</p>
            <input type="checkbox" name="ediE" class="check" id="" ref=""
              v-model.trim="EdiPerVista.edicionE"
              :disabled = '!habBotAndCamp.habEdiPer'>
          </div>
          <div class="EtiCamp2">
            <p>Privado</p>
            <input type="checkbox" name="privado" class="check" id="" ref=""
              v-model.trim="EdiPerVista.privado"
              :disabled = '!habBotAndCamp.habEdiPer'>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" class="inputfile"
            @change="getPortada" :disabled = '!habBotAndCamp.habEdiPer'/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar portada</p>
          </div>
        </div>
        <img class="imgPort2" :src="EdiPerVista.imgPortada"/>
        </form>
      </div>
      <div class="Btns">
        <BotonesCRUD
          :desacMas="!habBotAndCamp.actMas1"
          :desacEdit="!habBotAndCamp.actEdi1"
          :desacMenos="!habBotAndCamp.actMen1"
          :desacSave="!habBotAndCamp.actSav1"
          @nuevo="recibeBotonMasPubPer"
          @editar="recibeBotonEdiPubPer"
          @del="borrarPubPer"
          @save="savePubPer"
        />
        <div class="Btn-EdiPer">
          <BotonesCRUD
            :desacMas="!habBotAndCamp.actMas2"
            :desacEdit="!habBotAndCamp.actEdi2"
            :desacMenos="!habBotAndCamp.actMen2"
            :desacSave="!habBotAndCamp.actSav2"
            @nuevo="nuevaEdiPer"
            @editar="editarEdiPer"
            @del="borrarEdiPer"
            @save="saveEdiPer"
          />
        </div>
      </div>
    </section>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import axios from 'axios'
export default {
  name: 'FormPubPer',
  components: { BotonesCRUD },
  created () {
    // Trae datos de publicaciones periódicas de la coleccion 'pubpers'
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getPublicaciones()
    this.activaModo('INI')
  },
  data () {
    return {
      meses: ['<Elige mes de edición>', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      previewPortada: null,
      portada: '',
      pubs_per: [],
      pubs_perBkUp: [],
      VerSelectPubPer: true,
      PubPerSel: [],
      PubPerSelBkUp: [],
      PubPerVista: {
        // ID: '',
        nombre: '',
        editor: '',
        ciudad: '',
        pais: '',
        ISSN: '',
        idioma: ''
      },
      PubPerVistaBkUp: {},
      numVolEdiPers: {},
      EdiPerVista: {
        indice: ''
      },
      EdiPerVistaBkUp: {},
      EdiPerSel: [],
      habBotAndCamp: {
        actMas1: false,
        actEdi1: false,
        actMen1: false,
        actSav1: false,
        habPubPer: false,
        actMas2: false,
        actEdi2: false,
        actMen2: false,
        actSav2: false,
        habEdiPer: false
      },
      modoBkUp: [],
      IsModoSalirMasEdi: false,
      IsModoSalirEdiEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    getPublicaciones () {
      const url = `${this.URLbase}/pubsPers/getPubsPers`
      axios.get(url)
        .then(result => {
          const pubsPers = result.data
          this.pubs_per = pubsPers
        })
        .catch(error => alert(error))
    },
    mostrarPubPerVista (PubPer) {
      this.PubPerVista = PubPer
      this.blanquearEdiPerVista()
      this.activaModo('CSPN')
      if (this.PubPerSel._id) {
        this.getNumVolEdiPer(this.PubPerSel._id)
      }
    },
    setFocus () {
      // setTimeout(() => { this.$refs.enfoco.focus() }, 300)
      setTimeout(() => { this.$refs.nomPubPer.focus() }, 300)
    },
    // clic en Nuevo o Editar muestra alternativamente el select o el input
    // (para crear o editar) del nombre de la publicación periódica y en el componente
    // BotonesCRUD se cambia el nombre del botón: Edi <> Cancelar
    // VerSelectPubPer es la varible lógica de los v-show
    recibeBotonMasPubPer () {
      this.VerSelectPubPer = !this.VerSelectPubPer
      this.VerSelectPubPer ? this.botonSalMasPubPer() : this.botonMasPubPer()
    },
    botonMasPubPer () {
      this.PubPerVistaBkUp = JSON.parse(JSON.stringify(this.PubPerVista))
      this.EdiPerSelBkUp = this.EdiPerSel
      this.EdiPerVistaBkUp = this.EdiPerVista
      this.modoBkUp = JSON.parse(JSON.stringify(this.habBotAndCamp))
      this.blanquearPubPerVista()
      this.blanquearEdiPerVista()
      this.activaModo('CMAS')
      this.setFocus()
    },
    botonSalMasPubPer () {
      this.PubPerVista = JSON.parse(JSON.stringify(this.PubPerVistaBkUp))
      this.EdiPerSel = this.EdiPerSelBkUp
      this.EdiPerVista = this.EdiPerVistaBkUp
      this.habBotAndCamp = JSON.parse(JSON.stringify(this.modoBkUp)) // restaura MODO previo
      // this.getNumVolEdiPer(this.PubPerSel.ID)
    },
    blanquearPubPerVista () {
      this.PubPerVista = {}
      // this.PubPerVista = { ID: '0' }
    },
    recibeBotonEdiPubPer () {
      this.VerSelectPubPer = !this.VerSelectPubPer
      this.VerSelectPubPer ? this.botonSalEdiPubPer() : this.botonEdiPubPer()
    },
    botonEdiPubPer () {
      this.PubPerVistaBkUp = JSON.parse(JSON.stringify(this.PubPerVista))
      this.PubPerSelBkUp = JSON.parse(JSON.stringify(this.PubPerSel))
      this.pubs_perBkUp = JSON.parse(JSON.stringify(this.pubs_per))
      this.modoBkUp = JSON.parse(JSON.stringify(this.habBotAndCamp))
      this.activaModo('CEDI')
    },
    botonSalEdiPubPer () {
      this.pubs_per = JSON.parse(JSON.stringify(this.pubs_perBkUp))
      this.PubPerVista = JSON.parse(JSON.stringify(this.PubPerVistaBkUp))
      this.PubPerSel = JSON.parse(JSON.stringify(this.PubPerSelBkUp))
      this.habBotAndCamp = JSON.parse(JSON.stringify(this.modoBkUp)) // restaura MODO previo
    },
    cambioFormPubPer () {
      if (this.PubPerVista.nombre) {
        this.habBotAndCamp.actMas1
          ? this.activaModo('CMASs')
          : this.activaModo('CEDIs')
      }
      // si se activa esta función es que algo cambió en el formulario de pubs_per.
      // Para que se active el botón de guardar tiene que darse:
      // En el caso de Nuevo registro- Que el nombre no esté vacío
      // En el caso de edición- Lo mismo
    },
    async borrarPubPer () {
      if (this.numVolEdiPers.length > 0) {
        this.alertJoa('No se puede borrar una publicación periódica que tiene edicones registradas, primero hay que eliminar la ediciones.')
      } else {
        const response = await this.$root.alertJoa(
          'Estás a punto de borrar esta publicación periódica. Esta acción no puede revertirse ¿Quieres continuar?',
          'W', 'C')
        if (response === 'borrar') {
          const url = `${this.URLbase}/pubsPers/deletePubPer`
          const pubPerId = { _id: this.PubPerVista._id }
          try {
            const result = await axios.post(url, pubPerId, {
              headers: {
                authorization: this.token
              }
            })
            // console.log('Resultado:', result.status)
            switch (result.status) {
              case 200:
                this.blanquearPubPerVista()
                this.alertJoa('¡Registro borrado con éxito!', 'S')
                this.getPublicaciones()
                this.activaModo('INI')
                break
              case 500:
                this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                break
              default:
                this.alertJoa('Algo salió mal, intenta otra vez', 'E')
            }
          } catch (error) {
            alert(error)
            this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
          }
        }
      }
    },
    savePubPer () {
      const url = `${this.URLbase}/pubsPers/save`
      const pubPerData = this.PubPerVista
      axios.post(url, pubPerData)
        .then(result => {
          if (result.data === 'success') {
            this.alertJoa('Datos guardados', 'S')
          } else {
            this.alertJoa('Error guardando los datos, intenta otra vez', 'E')
          }
          this.getPublicaciones()
        })
        .catch(error => alert(error))
      this.VerSelectPubPer = true
      this.blanquearPubPerVista()
      this.PubPerSel = []
      if (this.EdiPerSel.Id) {
        this.activaModo('CSPS')
      } else {
        this.activaModo('CSPN')
      }
    },
    getNumVolEdiPer (PubPerId) {
      if (!PubPerId) { return }
      const url = `${this.URLbase}/edisPers/getNumVol`
      const pubPerId = { _id: PubPerId }
      axios.post(url, pubPerId)
        .then(result => {
          const numVolEdi = result.data
          this.numVolEdiPers = numVolEdi
          this.numVolEdiPers.length > 0 ? this.activaModo('CSPNp') : this.activaModo('CSPN')
        })
        .catch(error => alert(error))
    },
    async getDatosEdiPer (EdiPerID) {
      try {
        const url = `${this.URLbase}/edisPers/getEdiPerData`
        const ediPerId = { _id: EdiPerID }
        axios.post(url, ediPerId)
          .then(result => {
            const ediPerData = result.data
            this.EdiPerVista = ediPerData
          })
          .catch(error => alert(error))
      } catch (error) {
        alert(error)
      }
    },
    mostrarEdiPerVista (EdiPerID) {
      this.getDatosEdiPer(EdiPerID)
      this.activaModo('CSPS')
    },
    blanquearEdiPerVista () {
      this.EdiPerSel = []
      this.nombresPonencias = {}
      this.EdiPerVista = {}
    },
    nuevaEdiPer () {
      this.IsModoSalirMasEdi = !this.IsModoSalirMasEdi
      if (this.IsModoSalirMasEdi) {
        this.EdiPerVistaBkUp = JSON.parse(JSON.stringify(this.EdiPerVista))
        this.EdiPerSelBkUp = this.EdiPerSel
        this.EdiPerVista = {}
        this.EdiPerVista = {
          numero: '',
          volumen: '',
          mes: '0',
          anyo: '',
          indice: '',
          imgPortada: '',
          numPaginas: '',
          ejemplares: '',
          size: '',
          edicionP: false,
          edicionE: false,
          privado: false,
          ubicacionPdf: '',
          pertenece: this.PubPerSel._id,
          pertNomCort: this.PubPerVista.nombreCorto
        }
        this.activaModo('PMAS')
        this.EdiPerSel = []
      } else {
        this.EdiPerSel = this.EdiPerSelBkUp
        if (this.EdiPerSel.nombre) {
          this.EdiPerVista = JSON.parse(JSON.stringify(this.EdiPerVistaBkUp))
          this.activaModo('CSPS')
        } else {
          this.activaModo('CSPN')
        }
      }
    },
    editarEdiPer () {
      this.IsModoSalirEdiEdi = !this.IsModoSalirEdiEdi
      if (this.IsModoSalirEdiEdi) {
        this.EdiPerVistaBkUp = JSON.parse(JSON.stringify(this.EdiPerVista))
        this.EdiPerSelBkUp = this.EdiPerSel
        this.activaModo('PEDI')
      } else {
        this.EdiPerVista = JSON.parse(JSON.stringify(this.EdiPerVistaBkUp))
        this.EdiPerSel = this.EdiPerSelBkUp
        this.activaModo('CSPS')
      }
    },
    cambioFormEdiPer () {
      if (this.IsModoSalirMasEdi && this.minDataEdiPer) {
        this.activaModo('PMASs')
      }
      if (this.IsModoSalirEdiEdi && this.minDataEdiPer) {
        this.activaModo('PEDIs')
      }
    },
    async borrarEdiPer () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de esta edición. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C')
      if (response === 'borrar') {
        const url = `${this.URLbase}/edisPers/deleteEdiPer`
        const ediPerId = { _id: this.EdiPerVista._id }
        try {
          const result = await axios.post(url, ediPerId, {
            headers: {
              authorization: this.token
            }
          })
          // console.log('Resultado:', result.status)
          switch (result.status) {
            case 200:
              this.blanquearEdiPerVista()
              this.alertJoa('¡Registro borrado con éxito!', 'S')
              this.getNumVolEdiPer(this.PubPerSel._id)
              break
            case 500:
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
              break
            default:
              this.alertJoa('Algo salió mal, intenta otra vez', 'E')
          }
        } catch (error) {
          // console.error(error)
          this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
        }
      }
    },
    saveEdiPer () {
      const url = `${this.URLbase}/edisPers/save`
      this.EdiPerVista.pertNomCort = this.PubPerVista.nombreCorto
      const ediPerData = this.EdiPerVista
      axios.post(url, ediPerData)
        .then(result => {
          if (result.data === 'success') {
            this.alertJoa('Datos guardados', 'S')
          } else {
            this.alertJoa('Error guardando los datos, intenta otra vez', 'E')
          }
          this.getNumVolEdiPer(this.PubPerSel._id)
        })
        .catch(error => alert(error))
      this.blanquearEdiPerVista()
      this.IsModoSalirMasEdi = false
      this.IsModoSalirEdiEdi = false
      this.activaModo('CSPN')
    },
    getPortada (event) {
      const portada = event.target.files[0] // Asignamos la imagen a nuestra data
      const tamaño = portada.size // Verificamos el tamaño de la imagen
      if (tamaño > 500000) {
        alert(
          'El tamaño del archivo es: ' +
            Math.round(tamaño / 1000) +
            'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb'
        )
      } else {
        const reader = new FileReader() // Cargamos la previsualización
        reader.readAsDataURL(portada)
        reader.onload = (e) => { this.EdiPerVista.imgPortada = e.target.result }
        // const formData = new FormData()
        // const imageURL = URL.createObjectURL(portada)
        // formData.append('imgPort', imageURL)
        // this.EdiPerVista.imgPortada = imageURL
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          break
        case 'CSPN':
          this.confModo = [1, 1, 1, 0, 0, 1, 0, 0, 0, 0]
          break
        case 'CSPNp':
          this.confModo = [1, 1, 0, 0, 0, 1, 0, 0, 0, 0]
          break
        case 'CMAS':
          this.confModo = [1, 0, 0, 0, 1, 0, 0, 0, 0, 0]
          break
        case 'CMASs':
          this.confModo = [1, 0, 0, 1, 1, 0, 0, 0, 0, 0]
          break
        case 'CEDI':
          this.confModo = [0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
          break
        case 'CEDIs':
          this.confModo = [0, 1, 0, 1, 1, 0, 0, 0, 0, 0]
          break
        case 'PMAS':
          this.confModo = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1]
          break
        case 'PMASs':
          this.confModo = [0, 0, 0, 0, 0, 1, 0, 0, 1, 1]
          break
        case 'CSPS':
          this.confModo = [1, 1, 0, 0, 0, 1, 1, 1, 0, 0]
          break
        case 'PEDI':
          this.confModo = [0, 0, 0, 0, 0, 0, 1, 0, 0, 1]
          break
        case 'PEDIs':
          this.confModo = [0, 0, 0, 0, 0, 0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    mes (numMes) {
      return this.meses[numMes]
    },
    formatoIndice () {
      const indice = this.EdiPerVista.indice
      // Reemplazar Middle Dot y Bullet por Full Stop
      let nuevoIndice = indice.replace(/·/g, '.').replace(/•/g, '.')
      // Remplazar espacios blancos entre puntos
      nuevoIndice = nuevoIndice.replace(/\. *\. */g, '.')
      // Remplazar cualquier caracter entre puntos
      nuevoIndice = nuevoIndice.replace(/\.{1}[^.\s]+\.{1}/g, '.').replace(/(\.+)[^.\s]+(\.+)/g, '$1$2')
      // Reducir secuencias largas de Full Stop a cuatro puntos
      nuevoIndice = nuevoIndice.replace(/\.{5,}/g, '....')

      this.EdiPerVista.indice = nuevoIndice
    }
  },
  computed: {
    minDataEdiPer () {
      return (this.EdiPerVista.numero && this.EdiPerVista.anyo)
    },
    edicion () { // No funciona. Hay que tomar los datos que vienen de la BD y procesarlos antes de iterarlos para el select
      if (this.EdiPerVista.volumen) {
        return ('N°' + this.EdiPerVista.numero + ' Vol. ' + this.EdiPerVista.volumen + ' ' + this.EdiPerVista.anyo)
      } else {
        return ('N°' + this.EdiPerVista.numero + ' ' + this.EdiPerVista.anyo)
      }
    },
    longitudInd () {
      return (this.EdiPerVista.indice ? this.EdiPerVista.indice.length : 0)
    },
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: grid;
  grid-template-columns: 1fr 80vw;
  /* border: solid 0.5px orange; */
  overflow: hidden;
}
aside.Blk-1 {
  background-color: var(--az-cl-tr08);
  border: 0.5px var(--az-cl-tr08);
}
.previewPortada {
  /* border: solid palevioletred 1px;*/
  width: 90%;
  max-width: 200px;
  margin-top: 60px;
  box-shadow: rgb(43, 42, 42) 5px 5px 7px;
}
.imgPort2{
  display:none;
}
.Btn-EdiPerTel{
  display:none;
}
section.Blk-2 {
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x:hidden;
}
.Form {
  padding-top: 20px;
  /* display:flex;
  flex-direction: column; */
}

.Btns {
  display: grid;
  padding-left: 25px;
  padding-top: 20px;
}
.EtiCampV {
  flex:20;
  display: flex;
  flex-direction: column;
  height: 44px;
  /*  */

}
.EtiCampH {
  flex:20;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 4px;
}
.EtiCampI{
  flex:20;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.EtiCamp2 {
  flex:20;
  display: flex;
  flex-direction: row;
  /* border: solid 1px orange; */
  flex-shrink: 10;
  padding-top: 10px;
  align-items: center;
}
.EtiCampH p, .EtiCampV p, .EtiCamp2 p, .EtiCampI p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
  /* border: solid 0.5px orange; */
}
.EtiCamp2 p {
  max-width: 50px;
  min-width: 50px;
}
p#PubReg{
  font-weight: bold;
}
#SelPubReg{
  font-weight: bold;
  min-height: 28px;
  max-width: 100%;
  text-overflow: ellipsis;
}
#SelMes{
  min-height: 28px;
}
.formPubPer{
  padding-bottom: 11px;
  border-bottom: solid 1px rgb(78, 78, 78);
}
#edicionesSelect {
  margin-top: 12px;
  font-weight: bold;
}
#edicionesSelect p{
  font-weight: bold;
}
#edicionesSelect select{
  min-height: 28px;
  font-weight: bold;
  max-width: 330px;
}
.TipoM {
  display: flex;
  flex:20;
  flex-wrap: wrap;
  /* border: solid 1px orange; */
  flex-shrink: 10;
  padding-top: 2px;
}
/* .Multi {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex:20;
  justify-content:space-between;
} */

.campo {
  min-height: 26px;
  max-height: 26px;
  width: auto;
  min-width: 70px;
  margin-left: 10px;
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  /* flex-shrink: 1; */
  /* border: solid 0.5px orange; */
}
.campo:focus{
  outline: none;
}
#campo {
  height: 25px;
  width: auto;
  min-width: 70px;
  margin-left: 10px;
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 20;
  /* flex-shrink: 1; */
}
/* .EtiCampV #indice{
  min-height: 150px;
} */
.indice{
  max-width: 97.5%;
  height: 150px;
  background-color: var(--gr-fo-cam);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  color: var(--tx-cam);
  font-size: 14px;
  margin-left: 10px;
  padding-left: 8px;
}
.formInd button{
  justify-self: right;  /* No funciona*/
  margin-left: 80%;
  margin-top: 3px;
}
/*---------------------------------------------------------------------*/
/* Este es el estilo para el boton de cargar portada/contraportada */
/*Esta clase borra el aspecto tradicional del input file */
.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
.icon-icoSubirImg:disabled {
  color: rgb(57, 78, 82);
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 575px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  .Btn-EdiPer {
    display: none;
  }
  section.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    /* background-color: rgba(246, 245, 216, 0.911); */
  }
  .EtiCampH {
    flex-direction: column;
    align-items: stretch;
    width: 97%;
  }
  .campo {
    width: 96%;
  }
  .TipoM {
    width: 95%;
  }
  p#PubReg{
    max-width: 100%;
  }
  .Btns {
    padding: 0 3% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
  }
  .Btn-EdiPerTel {
    display: flex;
    padding: 0 3% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
    position: sticky;
  }
  .imgPort2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
  #in-dice{
    max-width: 93%;
    height: 200px;
  }
  .formInd button{
    margin-left: 60%;
    align-self: end; /* funciona pero pone la etiqueta del botón en dos líneas*/
}
}
</style>
